import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import S3Manager from 'components/S3Manager'
import { handleSectionValueChange } from 'actions/customForm/addOrEdit'
import Field from 'components/AddOrEditFormPage/CustomForm/Field'
import Button from 'components/theme/Button'
import {
	Dialog,
	DialogContent,
	DialogActions,
	// IconButton,
	withStyles,
	withMobileDialog,
} from '@material-ui/core'

class image extends Component {
	state = { open: false }

	render() {
		return this.props.isEditing ? (
			<>
				<div
					style={{
						paddingTop: 10,
					}}
				>
					<div
						style={{
							position: 'relative',
						}}
					>
						<div
							style={{
								width: 'calc(100% - 100px)',
							}}
						>
							<Field
								label="URL"
								property="url"
								statePath={(state) =>
									state.customForm.addOrEdit.sectionsByID[this.props.item.id]
										.url
								}
								placeholder="Enter an image url"
								sectionID={this.props.item.id}
							/>
						</div>
						<div className={this.props.classes.browseButton}>
							<Button
								color="secondary"
								variant="contained"
								onClick={() =>
									this.setState({
										open: true,
									})
								}
							>
								Browse
							</Button>
						</div>
					</div>
					<Field
						label="Label"
						property="label"
						statePath={(state) =>
							state.customForm.addOrEdit.sectionsByID[this.props.item.id]?.label
						}
						placeholder="Enter a label for your image"
						sectionID={this.props.item.id}
					/>
				</div>
				<Dialog
					open={this.state.open}
					aria-labelledby="responsive-dialog-title" // style={{ borderRadius: 22 }}
					fullScreen={this.props.fullScreen}
					fullWidth
					maxWidth="xl"
					PaperProps={{
						classes: {
							rounded: this.props.classes.rounded,
						},
					}}
				>
					<DialogContent
						classes={{
							root: this.props.classes.dialogContentRoot,
						}}
					>
						<S3Manager
							clickFile={(url) => {
								this.props.handleSectionValueChange({
									id: this.props.item.id,
									property: 'url',
									value: url,
								})
								this.setState({ open: false })
							}}
						/>
					</DialogContent>
					<DialogActions
						classes={{
							root: this.props.classes.dialogActionsRoot,
						}}
					>
						<Button
							onClick={() => {
								this.setState({
									open: false,
								})
							}}
							color="secondary"
						>
							Close
						</Button>
					</DialogActions>
				</Dialog>
			</>
		) : (
			<img
				src={this.props.item?.url}
				alt={this.props.item?.label || ''}
				style={{
					maxWidth: '100%',
					borderRadius: 8,
				}}
			/>
		)
	}
}

const styles = (theme) => ({
	rounded: {
		borderRadius: 28,
		[theme.breakpoints.down('sm')]: {
			borderRadius: 0,
		},
	},
	dialogContentRoot: {
		padding: 0,
		'&:first-child': { paddingTop: 0 },
	},
	dialogActionsRoot: {
		margin: 0,
		padding: '8px 4px',
		borderTop: '1px solid #808080',
	},
	browseButton: {
		top: 8,
		right: 0,
		position: 'absolute',
	},
})

export default connect(null, (dispatch) =>
	bindActionCreators({ handleSectionValueChange }, dispatch),
)(withStyles(styles)(withMobileDialog()(image)))
